export const FOLDER_SELECTED = "sidebar/FOLDER_SELECTED";
export const RESET_SIDEBAR = "sidebar/RESET";
export const SHOW_APP_UPDATE_MODAL = "sidebar/SHOW_APP_UPDATE_MODAL";
export const HIDE_APP_UPDATE_MODAL = "sidebar/HIDE_APP_UPDATE_MODAL";
